<!-- Navigation -->


<fuse-vertical-navigation [class.dark]="true" class="backdrop-blur-md bg-black/40 print:hidden "
    [class.hidden]="hideShellForFullscreenRoute"
    [mode]="navigationMode" [name]="'mainNavigation'" [navigation]="navigation.default"
    [opened]="navigationOpened" [inner]="false">


    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>

        <div class="flex items-center w-full p-2">

            <div class="flex items-center ml-auto">
                <user-profile [showAvatar]="false"></user-profile>
            </div>

        </div>

        <div class="flex flex-col items-center w-full mb-4">

            <!-- Avatar or Logo -->
            <div class="relative w-36 h-36 rounded-xl overflow-hidden border-2 border-white/40 shadow-lg bg-white/60 flex items-center justify-center">
                <!-- Show avatar if loaded successfully -->
                <img *ngIf="!avatarLoadError" 
                     [src]="photoLink(avatar)" 
                     (error)="errorHandler($event)"
                     class="w-full h-full object-cover"
                     [alt]="displayName">
                <!-- Show animated logo if avatar failed to load -->
                <app-navizard-logo *ngIf="avatarLoadError" 
                                   [usePreset]="true" 
                                   [isLight]="false" 
                                   [logoType]="'v1'"></app-navizard-logo>
            </div>

            <div class="flex flex-col items-center justify-center w-full mt-2">

                <div
                    class="w-full whitespace-nowrap overflow-ellipsis overflow-hidden text-center leading-normal font-mediu">
                    {{displayName}}
                </div>
                <div
                    class="w-full mt-0.5 whitespace-nowrap overflow-ellipsis overflow-hidden text-center text-md leading-normal font-medium ">
                    {{userName}}
                </div>

            </div>

        </div>
    </ng-container>

    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter>

        <div class="flex flex-0 items-center justify-center h-64 pr-6 pl-2 mt-2 mb-4 opacity-12">

            <app-navizard-logo class="w-36 h-36" [usePreset]="true" [isLight]="true"
                [logoType]="'v1'"></app-navizard-logo>
        </div>

    </ng-container>

    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationFooter>

        <div
            class="p-2 text-xs text-center justify-center font-semibold text-gray-600 dark:text-gray-300 bg-transparent">
            <app-navizard-versioning></app-navizard-versioning>
        </div>
    </ng-container>

</fuse-vertical-navigation>


<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 min-h-screen overflow-hidden relative">

    <div *ngIf="showShellHeader && !hideShellForFullscreenRoute" class="absolute inset-0 safe-area">
        <!-- DEBUG Badge, eğer debug modu aktifse -->
        <div *ngIf="globals.isDebugMode" class="ribbon up scale-[0.7] md:scale-100" style="--color: #b71f17;">
            <div class="content">
                <a [routerLink]="['settings']" fragment="Performance-Browser-EnableDebug">
                    <div>DEBUG<br>MODE</div>
                </a>
            </div>
        </div>
        <div
            class="frosty flex items-center h-16 px-1 mt-3 ml-3 mr-3 mx-auto top-0 z-10 print:hidden absolute inset-0 ">
            <button *ngIf="showShellHeader" mat-icon-button (click)="toggleNavigation('mainNavigation')">
                <fa-icon [icon]="['fal', 'bars']" class="text-2xl"></fa-icon>
            </button>
            <!-- Components -->
            <div class="flex-grow"></div> <!-- Bu div sol taraftaki boşluğu dolduracak -->
            <div class="flex flex-col items-center space-y-1">
      
                <div *ngIf="!(networkStatusService.isOnline | async)"
                    class="text-center bg-white/70 ring-2 ring-white/10 border-none border-white/20 text-red-600 p-2 rounded-md  px-12 py-3 sm:py-1">
                    <div class="text-md text-red-500 ">
                        ÇEVRİMDIŞI
                    </div>
                    <div class="text-sm text-red-500 hidden sm:block">
                        Şu anda çevrimdışısınız. Görüntülenen bilgiler güncel olmayabilir.
                    </div>
                </div>

            </div>
            <div class="flex-grow"></div> <!-- Bu div sağ taraftaki boşluğu dolduracak -->
            <div class="flex items-center space-x-0.5 sm:space-x-2">

                @let toastMuted = (toastMuted$ | async) ?? false;

                <div class="relative flex items-center">
                    <button mat-icon-button
                        [matMenuTriggerFor]="notificationMenu"
                        #notificationMenuTrigger="matMenuTrigger"
                        [matTooltip]="'SystemAdmin.Notifications.Title' | translate"
                        class="notification-nav-trigger relative transition-all duration-200"
                        [ngClass]="toastMuted ? 'text-red-500/60 hover:text-red-600/70' : 'text-slate-700 hover:text-slate-900'">
                        <fa-icon [icon]="toastMuted ? ['fas', 'bell-slash'] : ['fal', 'bell']" class="icon-size-5"></fa-icon>
                        <span *ngIf="notificationBadgeCount$ | async as badgeCount">
                            <span *ngIf="badgeCount > 0"
                                class="absolute right-0 top-0 flex h-3.5 min-w-3.5 -translate-y-0.5 translate-x-0.5 items-center justify-center rounded-full px-0.5 text-[8px] font-semibold leading-none ring-2 transition-colors duration-200"
                                [ngClass]="toastMuted ? 'bg-red-500/10 text-red-700/70 ring-red-500/10 shadow-none' : 'bg-red-500 text-white ring-white/80 shadow-sm'">
                                {{ badgeCount > 9 ? 9 : badgeCount }}
                            </span>
                        </span>
                    </button>
                    <span *ngIf="toastMuteCountdownLabel$ | async as countdownLabel"
                        class="absolute -bottom-0.5 left-1/2 -translate-x-1/2 text-[9px] leading-none text-white/60">
                        {{ countdownLabel }}
                    </span>
                </div>

                <mat-menu #notificationMenu="matMenu" class="notification-menu-panel" xPosition="before" yPosition="below">
                    <div class="relative w-96 max-w-[calc(100vw-2rem)] overflow-hidden rounded-2xl border border-slate-200/80 bg-white text-slate-900 shadow-2xl shadow-slate-900/20"
                        (click)="$event.stopPropagation()">
                        <span class="absolute -top-2 right-20 h-4 w-4 rotate-45 border-l border-t border-slate-200/80 bg-white"></span>

                        <div class="p-5">
                            <div class="flex items-start justify-between gap-3">
                                <div class="min-w-0">
                                    <div class="flex items-center gap-2">
                                        <h3 class="text-lg font-semibold leading-6 text-slate-950">
                                            {{ 'SystemAdmin.Notifications.Title' | translate }}
                                        </h3>
                                        <span class="h-2 w-2 rounded-full bg-emerald-500"></span>
                                        <span class="text-xs font-medium text-slate-600">
                                            {{ 'SystemAdmin.Notifications.Live' | translate }}
                                        </span>
                                    </div>
                                </div>

                                <span *ngIf="notificationBadgeCount$ | async as badgeCount"
                                    class="rounded-full bg-blue-50 px-2.5 py-1 text-xs font-semibold text-blue-700"
                                    [class.hidden]="badgeCount <= 0">
                                    {{ 'SystemAdmin.Notifications.NewCount' | translate: { count: badgeCount } }}
                                </span>
                            </div>

                            <div class="mt-5 text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-500">
                                {{ 'SystemAdmin.Notifications.Mute' | translate }}
                            </div>

                            <div class="mt-3 grid grid-cols-4 gap-2">
                                <button type="button"
                                    *ngFor="let option of notificationMuteOptions"
                                    (click)="muteNotificationsFor(option.seconds); notificationMenuTrigger.closeMenu()"
                                    class="h-10 rounded-xl border border-slate-200 bg-white px-3 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-red-500/20 hover:bg-red-500/10 hover:text-red-700/80"
                                    [attr.aria-pressed]="selectedNotificationMuteMode === option.mode"
                                    [ngClass]="selectedNotificationMuteMode === option.mode ? 'border-red-500/20 bg-red-500/10 text-red-700/80 ring-2 ring-red-500/10' : ''">
                                    <span class="inline-flex items-center justify-center gap-1">
                                        <fa-icon *ngIf="selectedNotificationMuteMode === option.mode"
                                            [icon]="['fas', 'check']" class="text-[10px]"></fa-icon>
                                        <span>{{ option.labelKey | translate }}</span>
                                    </span>
                                </button>

                                <button type="button"
                                    (click)="muteNotificationsToday(); notificationMenuTrigger.closeMenu()"
                                    class="h-10 rounded-xl border border-slate-200 bg-white px-3 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-red-500/20 hover:bg-red-500/10 hover:text-red-700/80"
                                    [attr.aria-pressed]="selectedNotificationMuteMode === 'today'"
                                    [ngClass]="selectedNotificationMuteMode === 'today' ? 'border-red-500/20 bg-red-500/10 text-red-700/80 ring-2 ring-red-500/10' : ''">
                                    <span class="inline-flex items-center justify-center gap-1">
                                        <fa-icon *ngIf="selectedNotificationMuteMode === 'today'"
                                            [icon]="['fas', 'check']" class="text-[10px]"></fa-icon>
                                        <span>{{ 'SystemAdmin.Notifications.MuteToday' | translate }}</span>
                                    </span>
                                </button>

                                <button type="button"
                                    (click)="unmuteNotifications(); notificationMenuTrigger.closeMenu()"
                                    class="h-10 rounded-xl border border-slate-200 bg-white px-3 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-emerald-300 hover:bg-emerald-50 hover:text-emerald-700"
                                    [attr.aria-pressed]="!toastMuted"
                                    [class.border-emerald-300]="!toastMuted"
                                    [class.bg-emerald-50]="!toastMuted"
                                    [class.text-emerald-700]="!toastMuted"
                                    [class.ring-2]="!toastMuted"
                                    [class.ring-emerald-200]="!toastMuted">
                                    <span class="inline-flex items-center justify-center gap-1">
                                        <fa-icon *ngIf="!toastMuted" [icon]="['fas', 'check']" class="text-[10px]"></fa-icon>
                                        <span>{{ 'SystemAdmin.Notifications.Unmute' | translate }}</span>
                                    </span>
                                </button>
                            </div>

                            <div *ngIf="toastMuted"
                                class="mt-4 flex gap-3 rounded-xl border border-red-500/10 bg-red-500/10 px-4 py-3 text-red-700/80">
                                <fa-icon [icon]="['fal', 'bell-slash']" class="mt-0.5 text-lg text-red-500/60"></fa-icon>
                                <div class="min-w-0">
                                    <div class="text-sm font-semibold">
                                        {{ 'SystemAdmin.Notifications.MutedActive' | translate }}
                                    </div>
                                    <div class="mt-0.5 text-sm font-medium text-red-700/70">
                                        <ng-container *ngIf="toastMuteRemainingMinutes$ | async as remainingMinutes">
                                            {{ 'SystemAdmin.Notifications.RemainingDuration' | translate: { duration: remainingMinutes } }}
                                        </ng-container>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-5 text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-500">
                                {{ 'SystemAdmin.Notifications.Actions' | translate }}
                            </div>

                            <div class="mt-3 grid grid-cols-2 gap-3">
                                <button type="button"
                                    (click)="clearToastNotifications()"
                                    class="h-11 rounded-xl border border-slate-200 bg-white px-3 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-red-200 hover:bg-red-50 hover:text-red-600">
                                    {{ 'SystemAdmin.Notifications.ClearNotifications' | translate }}
                                </button>
                                <button type="button"
                                    (click)="openNotifications()"
                                    class="h-11 rounded-xl border border-slate-200 bg-white px-3 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700">
                                    {{ 'SystemAdmin.Notifications.ViewAll' | translate }}
                                </button>
                            </div>

                            <div class="mt-5 border-t border-slate-100 pt-4 text-sm">
                                <div class="flex items-center justify-between gap-3 font-semibold text-slate-600">
                                    <span>{{ 'SystemAdmin.Notifications.PendingNotifications' | translate }}</span>
                                    <span class="text-slate-950">{{ (queuedMessageCount$ | async) ?? 0 }}</span>
                                </div>
                                <p class="mt-2 text-xs font-medium text-slate-500">
                                    {{ 'SystemAdmin.Notifications.MutedQueueHint' | translate }}
                                </p>
                            </div>
                        </div>
                    </div>
                </mat-menu>

                <button mat-icon-button *ngIf="updatePending$ | async"
                    (click)="applyPendingUpdate()" [matTooltip]="'Update available'" class="text-red-500">
                    <fa-icon [icon]="['fal' , 'sync']" class="icon-size-5"></fa-icon>
                </button>

                <ng-container *ngIf="isChatEnabled">
                    <button mat-icon-button [matTooltip]="'Chat'"
                        *ngrxLet="chatUnreadCount$ as chatUnreadCount" (click)="toggleChat()">
                        <span *ngIf="(chatUnreadCount ?? 0) > 0"
                            class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
                            <span
                                class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-red-500 z-10 text-indigo-50 text-xs font-medium">
                                {{ chatUnreadCount }}
                            </span>
                        </span>
                        <fa-icon [icon]="['fal' , 'comments']" class="icon-size-5"></fa-icon>
                    </button>
                </ng-container>

                


                <button mat-icon-button #shortcutsOrigin routerLinkActive routerLink="/live"
                    [matTooltip]="'Live Tracking'">
                    <fa-icon [icon]="['fal' , 'map-marked']" class="icon-size-5"></fa-icon>
                </button>

                <div class="relative flex items-center">
                    <button mat-icon-button (click)="screenSaver.activate()" [matTooltip]="'Screen Saver'">
                        <fa-icon [icon]="['fal' , 'lock']" class="icon-size-5"></fa-icon>
                    </button>
                    <span *ngIf="screenSaver.idleCountdown$ | async as idleCountdown"
                        class="absolute -bottom-0.5 left-1/2 -translate-x-1/2 text-[9px] leading-none text-white/60">
                        {{ idleCountdown }}s
                    </span>
                </div>

                <languages></languages>
                <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            </div>
        </div>
    </div>
    <!-- header -->


    <!-- Content -->

    <!-- <ng-scrollbar [visibility]="'hover'" >  -->
    <div class="app-layout-scroll absolute inset-0 overflow-y-auto overflow-x-hidden">
        <div class="">
            <div class="w-full">
                
                <router-outlet> </router-outlet>
                
            </div>
        </div>

    </div>
    <!-- </ng-scrollbar>  -->

    <div class="chat-floating-panel" *ngIf="isChatEnabled && isChatOpen && showShellHeader">
        <app-chat-widget [conversationId]="chatConversationId" (closed)="closeChat()"></app-chat-widget>
    </div>

</div>
